export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11025.5bf379d1.jpg";